/* eslint-disable jira/filename-case */
import type { WorkspaceId } from '@jira/servicedesk__insight-common-types-shared-types/src/toCmdbObjectTypeId.tsx';
import { getCmdbRestBaseUrl } from './getCmdbRestBaseUrl.tsx';

/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/tempeh
 */
export const getCmdbTempehUrl = (workspaceId: WorkspaceId): string =>
	`${getCmdbRestBaseUrl(workspaceId)}/tempeh`;

/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/tempeh/migration
 */
export const getCmdbTempehMigrationUrl = (workspaceId: WorkspaceId): string =>
	`${getCmdbTempehUrl(workspaceId)}/migration`;
